import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {getComponents} from "../utilities";
import Accordion from "../../components/accordion";

/**
 *  EquipmentContainer
 */
class EquipmentContainer extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    categoryTitle: PropTypes.string,
    equipmentItem: PropTypes.arrayOf(PropTypes.node),
    openModalWindow: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    categoryTitle: null,
    equipmentItem: null,
    openModalWindow: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {};
  }
  
  render() {
    
    // カテゴリ
    const renderCategory = () => {
      if (this.props.categoryTitle && this.props.categoryTitle !== '') {
        return (
          <Accordion
            pcText={this.props.categoryTitle}
            open={false}
            current={false}
            simpleAnimation={false}
          >
            {renderItems()}
          </Accordion>
        )
      } else {
        return (
          renderItems()
        )
      }
    };
    
    // アイテム
    const renderItems = () => {
      if (this.props.equipmentItem && 1 <= this.props.equipmentItem.length) {
        return (
          <ul className="EquipmentContainer__list">
            {this.props.equipmentItem.map((item, index) => {
              return (
                <li key={index}>
                  {getComponents([item], {
                    openModalWindow: (e)=> {
                      if (this.props.openModalWindow !== null) {
                        this.props.openModalWindow(Object.assign(e, {itemIndex: index}));
                      }
                    },
                  })}
                </li>
              )
            })}
          </ul>
        )
      } else {
        return null;
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <section className="EquipmentContainer">
          {renderCategory()}
        </section>
      </Wrapper>
    )
  }
  
}

export default EquipmentContainer;



// WEBPACK FOOTER //
// ./src/containers/equipment-container/index.jsx